<div class="prospect-search">
  <input
    #inputElement
    type="text"
    class="form-control"
    [ngModel]="model"
    [ngbTypeahead]="search"
    [resultTemplate]="resultTemplate"
    [inputFormatter]="formatter"
    [placeholder]="'prospect_search.input_placeholder_l' | translate"
    (selectItem)="$event.preventDefault()"
    (focus)="focus$.next($any($event).target.value)"
  />
  <svg-icon
    src="/assets/images/icons/icon-search.svg"
    [applyClass]="true"
    [svgStyle]="{ 'width.px': 30 }"
    class="default-svg-color circle path"
    role="button"
    (click)="inputElement.focus()"
  ></svg-icon>
  @if (isSearching$ | async) {
    <app-loading-spinner></app-loading-spinner>
  }
</div>

<ng-template #resultTemplate let-result="result" let-term="term">
  <dl class="prospect-search-result">
    <ngb-highlight
      result="{{ result.firstname }} {{ result.name }}"
      [term]="term"
    ></ngb-highlight>

    @if (result.items.length) {
      <div class="prospect-search-result__property">
        @for (
          item of result.items
            | slice
              : 0
              : (searchDataMap.get(result.userId) ? result.items.length : 3);
          track item.name
        ) {
          <dd
            class="prospect-search-result__property-name py-1"
            (click)="redirectToFlat(item)"
          >
            {{ item.name }} - {{ item.address | appAddress }}
          </dd>
        }
        @if (result.items.length > 3) {
          <span
            class="toggle-size"
            (click)="
              searchDataMap.get(result.userId)
                ? searchDataMap.delete(result.userId)
                : searchDataMap.set(result.userId, true);
              $event.stopPropagation()
            "
          >
            {{
              (searchDataMap.get(result.userId)
                ? 'search.show_less_a'
                : 'search.show_more_a'
              ) | translate
            }}
          </span>
        }
      </div>
    }
  </dl>
</ng-template>
